webpackJsonp([274166807202101],{

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _DocPage = __webpack_require__(20);
	
	var _DocPage2 = _interopRequireDefault(_DocPage);
	
	var _Anchor = __webpack_require__(41);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _CodeSample = __webpack_require__(5);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	var _NextButton = __webpack_require__(62);
	
	var _NextButton2 = _interopRequireDefault(_NextButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _DocPage2.default,
	    { title: 'Localization' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'react-day-picker can be localized into any language (English being the default). You can either:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'use the localization props \u2013 see the',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '#localization-props' },
	          'example below'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: '#moment' },
	          'use moment.js'
	        ),
	        ' translations strings, in case you are already including it in your project'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For more advanced options, such as changing how days and captions are displayed, see ',
	      _react2.default.createElement(
	        'a',
	        { href: '#advanced' },
	        'advanced localization'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Localization props'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Use ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'locale'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'weekdaysLong'
	      ),
	      ' and',
	      _react2.default.createElement(
	        'code',
	        null,
	        'weekdaysShort'
	      ),
	      ' props with your own translation strings. Use',
	      ' ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'firstDayOfWeek'
	      ),
	      ' to set the first day of the week.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The following example translates the calendar in Italian:'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'localization-01' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      _react2.default.createElement(_Anchor2.default, { id: 'localization-moment' }),
	      'Localization with moment.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you already include ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://www.momentjs.com' },
	        'moment.js'
	      ),
	      ' in your dependencies, you may find convenient to use moment\u2019s translation strings.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'How to use moment.js to localize the calendar'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'make sure ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'moment'
	        ),
	        ' is included in your dependencies'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'make sure the required moment\u2019s locale data is available when rendering react-day-picker'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'import ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'MomentLocaleUtils'
	        ),
	        ' from',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'react-day-picker/moment'
	        ),
	        ' and pass it to the',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'localeUtils'
	        ),
	        ' props'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'use the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'locale'
	        ),
	        ' prop to set the locale in react-day-picker'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The following example shows how to localize the calendar in English, Japanese, Arabic and Italian:'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'examples/localization-moment' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Advanced localization'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Internally, react-day-picker uses',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/api/LocaleUtils' },
	        'LocaleUtils'
	      ),
	      ', a set of formatting functions. You can overwrite its behavior by passing your own custom functions to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'localeUtils'
	      ),
	      ' props.'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'localization-03' }),
	    _react2.default.createElement(_NextButton2.default, { to: '/docs/input', label: 'Using DayPickerInput' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-docs-localization-js-4a222e5ab86f039a8fe2.js